import React, { ChangeEvent, useEffect, useState } from "react";
import "./OrderSearch.css";
import { FormControl, InputLabel, NativeSelect } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import money from "../../../../assets/Images/1635d86b32b60583e7f022b9c3324b3d.png";
import payimg from "../../../../assets/Images/pay.png";
import Dones from "../../../../assets/Images/success-image.png";
import api from "../../../../features/auth/axiosConfig";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import CommonButtons from "../../../../shared/components/CommonButtons";
import OrderProductsList from "./OrderDisplay/components/OrderProductsList";
import OrderCustomerInfo from "./OrderDisplay/components/OrderCustomerInfo";
import OrderPriceDetails from "./OrderDisplay/components/OrderPriceDetails";
import OrderPaymentMethods from "./OrderDisplay/components/OrderPaymentMethods";
import PaymentSummaryModal from "./OrderDisplay/modals/PaymentSummaryModal";
import CashPaymentSummaryModal from "./OrderDisplay/modals/CashPaymentSummaryModal";
import PaymentConfirmModal from "./OrderDisplay/modals/PaymentConfirmModal";
import CancelOrderDialog from "./OrderDisplay/modals/CancelOrderDialog";
import { Customerdata, Getdata } from "../../../../shared/services/interface";
import { getOrdersApi, getLedgerByCustomerIdApi } from "./OrderDisplay/api";
import { useOrderDisplay } from "../../../../shared/hooks/useOrderDisplay";
import { date, orderback, Doneorder, formatNumber, formatNumbers, SendMail, SendMessage, COMPLETE, Update, Cancel, OrderUpdate, orderemailmsg } from "./OrderDisplay/orderHelpers";
import { cancelOrder, handleChange, updateCustomerEmail, validateAndSetEmail } from "./OrderDisplay/services/orderServices";
import { PageTitle } from "src/shared/PageTitle";
import LoadingScreen from "src/shared/components/LoadingScreen";
import { useCustomer } from "../home/Done/hooks/useCustomer";
import BootstrapInput from "src/shared/modules/settings/categories/components/BootstrapInput";
import { useUser } from "src/business-types/grocery/components/UserContext";

const OrderDisplay: React.FC = () => {
  const [getorder, setGetOrder] = useState<Getdata>();
  const [bproducts, setbuttonname] = useState<Getdata>();
  const [confirmemail, setconfirmemail] = useState("");
  const [email, setEmail] = useState("");
  const [geterror, setGeterror] = useState<any>("");
  const [move, setmove] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [agent, setAgent] = useState<boolean>(false);
  const [customer, setCustomerData] = useState<Customerdata>();
  const { customerData } = useCustomer(getorder?.Customerid);
  const [ordersucess, setOrdersucess] = useState<Getdata>();
  const [showPaymentMethods, setShowPaymentMethods] = useState<string>("");
  const [ffamilys, setffamily] = useState<string>("");
  const [outstangingamount, setoutstangingamount] = useState<Customerdata>();
  const [, setemployeesData] = useState(false);
  const [logo, setlogo] = useState<any>();
  const [time, setTime] = useState({ hours: "", minutes: "", seconds: "", day: "", month: "", year: "" });
  const navigate = useNavigate();
  const { orderid } = useParams();
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [cancelData, setCancelData] = useState<string>("refund");
  const { userConfigration } = useUser();
  const [cancelLoading, setCancelLoading] = useState(false);

  const {
    printData,
    Remainingpayments,
    Receivedbalance,
    remaining,
    roundValue,
    cashoutstanging,
    Outamount,
    refundAmount,
    handleclick,
    handleBlur,
    outstandingvalue,
    payments,
    inputValue,
    condition,
    model,
    glowery,
    confirm,
    setmodel,
    setglowery,
    setConfirm,
    setPrintHistory,
    setpaylate,
    setcashpay,
    paylate,
    cashpay,
    paycard,
    setpaycard,
  } = useOrderDisplay({ bproducts, orderid: orderid || "", logo, outstangingamount: Number(outstangingamount ?? 0), getorder, sessionStorage });

  const { clientId: filteredCustomerId } = useCustomer(getorder?.Customerid || bproducts?.Customerid);

  useEffect(() => {
    date(setTime);
    const bussness = sessionStorage.getItem("organization_name");
    const storedColor = sessionStorage.getItem(`background_color${bussness}`);
    const ffamily = sessionStorage.getItem(`font_family${bussness}`);
    if (ffamily) {
      setffamily(ffamily);
      document.documentElement.style.setProperty("--fontfamily", ffamily);
    }
    if (storedColor) {
      document.documentElement.style.setProperty("--background-color", storedColor);
    }
  }, []);

  useEffect(() => {
    document.title = "Order › Details › iMetanic";
    if (!orderid) {
      return;
    }
    getOrdersIn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const employee = () => {
      const employeeData = sessionStorage.getItem("employee");
      if (employeeData) {
        setemployeesData(true);
      } else {
        setemployeesData(false);
      }
    };
    employee();
    const bussnessname = sessionStorage.getItem("organization_name");
    const logo = sessionStorage.getItem(`Logo${bussnessname}`);
    setlogo(logo);
  }, []);

  const droupdown = () => {
    const handleDelivered = () => {
      toast.success("Order has been delivered successfully!", { autoClose: 2000 });
    };
    type StatusOption = { value: string; color: string; onClick?: () => void };
    type StatusType = "Confirm" | "In-process" | "Waiting for delivery" | "Delivered" | "Cancelled";
    const statusOptions: Record<StatusType, StatusOption[]> = {
      Confirm: [
        { value: "Confirm", color: "green" },
        { value: "In-process", color: "#FFD700" },
        { value: "Waiting for delivery", color: "blue" },
      ],
      "In-process": [
        { value: "In-process", color: "#FFD700" },
        { value: "Waiting for delivery", color: "blue" },
        { value: "Delivered", color: "green", onClick: handleDelivered },
      ],
      "Waiting for delivery": [
        { value: "Waiting for delivery", color: "blue" },
        { value: "Delivered", color: "green", onClick: handleDelivered },
      ],
      Delivered: [{ value: "Delivered", color: "green" }],
      Cancelled: [{ value: "Cancelled", color: "red" }],
    };
    const currentMove = move as StatusType;
    if (!statusOptions[currentMove]) return null;
    return (
      <FormControl sx={{ m: 1, fontFamily: ffamilys }} variant='standard' className='dropp_dow'>
        <InputLabel htmlFor='demo-customized-select-native'>Order status</InputLabel>
        <NativeSelect id='demo-customized-select-native' value={currentMove} onChange={handleChangeEvent} input={<BootstrapInput />}>
          {statusOptions[currentMove].map((option: StatusOption) => (
            <option key={option.value} className='dropp_downn' value={option.value} style={{ color: option.color }} onClick={option.onClick}>
              {option.value}{" "}
            </option>
          ))}
        </NativeSelect>
      </FormControl>
    );
  };

  const getOrdersIn = async (
    options = {
      fetchCustomer: false,
      fetchLedger: true,
      showLoading: true,
    },
  ) => {
    const { fetchCustomer = false, fetchLedger = true, showLoading = true } = options;

    if (showLoading) {
      setLoading(true);
    }

    try {
      const res = await getOrdersApi(orderid!);
      const buttonData: Getdata = res.data.result;

      // Always set order data
      setbuttonname(buttonData);
      setOrdersucess(buttonData);
      setGetOrder(buttonData);
      setmove(buttonData?.OrderStatus || "");

      // Update showPaymentMethods based on order status
      if (buttonData?.OrderStatus.includes("Waiting for delivery")) {
        setShowPaymentMethods("true");
      } else if (buttonData?.OrderStatus === "Delivered") {
        setShowPaymentMethods(""); // Hide payment methods for delivered orders
      }

      if (fetchLedger) {
        const customerid = buttonData?.Customerid;
        if (customerid) {
          const ledgerRes = await getLedgerByCustomerIdApi(customerid);
          const osb = ledgerRes.data.ledger.total_outstanding_balance;
          setoutstangingamount(osb);
          setCustomerData(ledgerRes.data.ledger);
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      if (showLoading) {
        setLoading(false);
      }
    }
  };

  const handleUpdateCustomerEmail = () => {
    updateCustomerEmail(getorder, confirmemail, ordersucess, email, setAgent, setGeterror, orderemailmsg, customerData || undefined);
  };
  const handleOrderEmailMsg = (getorder: any, email: string, received: string, orderId: string, finalAmount: number, remaining: string) => {
    const handleDone = () => {
      Doneorder();
      setConfirm(false);
    };
    if (!getorder) return;
    orderemailmsg(getorder, email, received, orderId, finalAmount, remaining, handleDone);
  };

  const handleCancel = async () => {
    if (cancelLoading) return;

    setCancelLoading(true);
    try {
      await cancelOrder(orderid, cancelData, setmove);

      await getOrdersIn({
        fetchCustomer: false,
        fetchLedger: false,
        showLoading: true,
      });

      setOpenCancelDialog(false); // ✅ close AFTER success
    } catch (err) {
      console.error(err);
    } finally {
      setCancelLoading(false);
    }
  };

  const handleChangeEvent = (event: ChangeEvent<HTMLSelectElement>) => {
    handleChange(orderid, event, setmove, () =>
      getOrdersIn({
        fetchCustomer: false,
        fetchLedger: false,
        showLoading: false,
      }),
    );
  };

  const handleConfirm = (Payment: string) => {
    const update = OrderUpdate({ getorder, condition, inputValue: Number(inputValue), outstangingamount: Number(outstangingamount), time, Payment });
    api.patch(`/app/v1/pos/order/${orderid}`, update).then((res) => {
      setmodel(false);
      setglowery(false);
      setConfirm(true);
      setPrintHistory(true);
      getOrdersIn();
    });
  };

  const customeremailid = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    validateAndSetEmail(value, setEmail, setconfirmemail);
  };
  const remainingBalance = Number(Outamount()) - condition;
  const formattedBalance = remainingBalance.toFixed(2);
  const totaloutstandingboc = Number(cashoutstanging) + Number(getorder?.RemainingAmount);
  const toBoolean = (value: any) => value === true || value === "true";

  const deliveryFeeEnabled = toBoolean(userConfigration?.deliveryFeeEnabled);

  return (
    <div className="flex flex-col overflow-hidden w-full" style={{ fontFamily: ffamilys }}>
      <PageTitle title="- Order › Details" />
      <div className="w-full h-full overflow-hidden ">
        <div className="thin-scrollbar w-full flex-1 flex flex-col lg:flex-row gap-4 p-2 h-[91.5vh] overflow-auto">
          <div className="lg:w-4/6 w-full p-2 h-[89vh] flex flex-col overflow-x-auto">
            <div className="mb-1.5">
              <CommonButtons label="BACK" onClick={() => navigate(-1)} variant="secondary" icon={KeyboardReturnIcon} />
            </div>
            <div className='flex-1 min-h-0 overflow-hidden'>
              <OrderProductsList products={getorder?.Products || []} />
            </div>
          </div>
          <div className='thin-scrollbar xl:w-4/12 lg:w-5/12 w-full h-[89vh] pr-1 flex flex-col flex-shrink-0 md:max-h-[89vh] max-h-[calc(100vh-80px)] lg:overflow-y-auto lg:overflow-x-hidden'>
            <OrderCustomerInfo orderId={getorder?.Orderid ?? "-"} customerName={getorder?.CustomerName ?? "-"} order={getorder} />
            <OrderPriceDetails
              roundValue={roundValue}
              totalAmount={getorder?.totalAmount ?? 0}
              discount={getorder?.discount ?? 0}
              deliveryFee={getorder?.deliveryFee ?? 0}
              deliveryFeeEnabled={deliveryFeeEnabled}
              finalAmount={getorder?.Finalamount ?? 0}
              receivedBalance={Receivedbalance() ?? 0}
              remaining={remaining() ?? 0}
              outstandingAmount={Number(outstangingamount ?? 0)}
              paymentMethod={getorder?.payments?.[0]?.Paymentmethod ?? "-"}
              orderDate={getorder?.Orderdate ?? "-"}
              orderTime={getorder?.Ordertime ?? "-"}
            />
            <OrderPaymentMethods
              ffamilys={ffamilys}
              droupdown={droupdown}
              showPaymentMethods={Boolean(showPaymentMethods)}
              remaining={remaining}
              outstangingamount={() => Number(outstangingamount ?? 0)}
              // outstandingAmount={() => Number(outstangingamount ?? 0)}
              payments={payments}
              getorder={getorder}
              setOpenCancelDialog={setOpenCancelDialog}
              filteredCustomerId={filteredCustomerId}
              printData={printData}
              COMPLETE={COMPLETE}
              paylate={paylate}
              cashpay={cashpay}
              setpaylate={setpaylate}
              setcashpay={setcashpay}
              paycard={paycard}
              setpaycard={setpaycard}
            />
            <CancelOrderDialog
              open={openCancelDialog}
              setOpenCancelDialog={setOpenCancelDialog}
              Remainingpayments={Number(Remainingpayments ?? 0)}
              cancelData={cancelData}
              setCancelData={setCancelData}
              roundValue={roundValue}
              Receivedbalance={() => Number(Receivedbalance() ?? 0)}
              // outstangingamount={Number(getorder?.RemainingAmount ?? 0)}
              outstangingamount={Number(outstangingamount)}
              getorder={getorder}
              refundAmount={refundAmount}
              cancelOrder={handleCancel}
            />
          </div>
        </div>
        <ToastContainer />
      </div>
      <PaymentSummaryModal
        model={model}
        setmodel={setmodel}
        orderback={() => orderid && orderback(orderid)}
        getorder={getorder}
        roundValue={roundValue}
        cashoutstanging={cashoutstanging}
        totaloutstandingboc={totaloutstandingboc}
        handleConfirm={handleConfirm}
        payimg={payimg}
        money={money}
        deliveryFeeEnabled={deliveryFeeEnabled}
      />
      <CashPaymentSummaryModal
        glowery={glowery}
        setglowery={setglowery}
        orderback={() => orderid && orderback(orderid)}
        getorder={getorder}
        roundValue={roundValue}
        cashoutstanging={cashoutstanging}
        totaloutstandingboc={totaloutstandingboc}
        handleConfirm={handleConfirm}
        payimg={payimg}
        money={money}
        inputValue={inputValue}
        handleclick={handleclick}
        handleBlur={handleBlur}
        Outamount={Outamount}
        formatNumber={formatNumber}
        formatNumbers={formatNumbers}
        formattedBalance={formattedBalance}
        outstandingvalue={outstandingvalue}
        deliveryFeeEnabled={deliveryFeeEnabled}
        paymenytMethod={paycard ? "Card" : "Cash"}
      />
      <PaymentConfirmModal
        getorder={getorder || undefined}
        confirm={confirm}
        setConfirm={setConfirm}
        emaihas={customer?.Email ? true : false}
        agent={agent}
        setAgent={setAgent}
        Customer={customer || undefined}
        email={email}
        geterror={geterror}
        customeremailid={customeremailid}
        updateCustomerEmail={handleUpdateCustomerEmail}
        orderemailmsg={handleOrderEmailMsg}
        Doneorder={() =>
          Doneorder(setConfirm, () =>
            getOrdersIn({
              fetchCustomer: false,
              fetchLedger: true,
              showLoading: true,
            }),
          )
        }
        ordersucess={ordersucess}
        filteredCustomerId={filteredCustomerId}
        printData={printData}
        SendMail={SendMail}
        Cancel={Cancel}
        Update={Update}
        SendMessage={SendMessage}
        Dones={Dones}
        loading={loading}
      />
      {loading && <LoadingScreen />}
    </div>
  );
};

export default OrderDisplay;
